import React from 'react'
import { connect } from 'react-redux'
import {
  Circle,
  Divider,
  Menu,
  MenuButton,
  MenuList,
  Drawer,
  DrawerContent,
  DrawerBody,
  DrawerOverlay,
  DrawerCloseButton,
  DrawerHeader,
  useDisclosure
} from '@chakra-ui/react'

import appMode from 'helpers/getAppMode'
import { getUnreadNotifications } from 'helpers/getUnreadNotifications'
import { readAppNotifications } from 'redux/actions/app.actions'
import NotificationsList from './sub/NotificationsList'
import AppNotificationButton from './sub/AppNotificationButton'

import './_AppNotification.scss'

const AppNotification = ({ notifications, readAppNotifications }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  if (!appMode.normal) return null
  const unread = getUnreadNotifications(notifications)
  const onDrawerClose = () => {
    onClose()
    if (unread.length) {
      readAppNotifications(unread)
    }
  }
  return (
    <Circle size="32px" pos="relative" data-tour="app-notifications">
      <AppNotificationButton
        as="button"
        display={{ base: 'flex', md: 'none' }}
        unread={unread}
        onClick={onOpen}
      />
      <Menu
        isLazy
        placement="bottom-end"
        onClose={() => {
          if (unread.length) {
            readAppNotifications(unread)
          }
        }}
      >
        <AppNotificationButton
          as={MenuButton}
          _focus={{ boxShadow: 'none' }}
          display={{ base: 'none', md: 'flex' }}
          unread={unread}
        />
        <MenuList overflow="auto" maxH="400px">
          <NotificationsList notifications={notifications} />
        </MenuList>
      </Menu>

      <Drawer
        display={{ md: 'none' }}
        autoFocus={false}
        placement="right"
        isOpen={isOpen}
        onClose={onDrawerClose}
        returnFocusOnClose={true}
        onOverlayClick={onDrawerClose}
        size="xs"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton onClick={onDrawerClose} />
          <DrawerHeader>Notifications</DrawerHeader>
          <Divider />
          <DrawerBody>
            <NotificationsList notifications={notifications} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      {unread.length > 0 && (
        <Circle
          pos="absolute"
          top="5px"
          right="5px"
          borderRadius="full"
          color="#fff"
          bg="brand.main"
          size="8px"
        />
      )}
    </Circle>
  )
}

const mapStateToProps = state => {
  return {
    notifications: state.app.notifications
  }
}

export default connect(mapStateToProps, {
  readAppNotifications
})(AppNotification)
